var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreak(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lunch Break"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.73703 9.38844C2.62596 7.72243 2.57043 6.88943 3.06443 6.3614C3.55842 5.83337 4.39328 5.83337 6.06298 5.83337H10.6037C12.2734 5.83337 13.1083 5.83337 13.6023 6.3614C14.0963 6.88943 14.0408 7.72243 13.9297 9.38844L13.6445 13.666C13.497 15.8784 13.4233 16.9846 12.7024 17.659C11.9816 18.3334 10.8729 18.3334 8.6556 18.3334H8.01113C5.79379 18.3334 4.68512 18.3334 3.96428 17.659C3.24344 16.9846 3.1697 15.8784 3.0222 13.666L2.73703 9.38844Z",
    stroke: "#4079FC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1667 14.1667H15C16.841 14.1667 18.3334 12.6743 18.3334 10.8333C18.3334 8.99238 16.841 7.5 15 7.5H14.1667",
    stroke: "#4079FC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3333 15H3.33331",
    stroke: "#4079FC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.04222 4.21776L5.3844 3.73803C5.57338 3.47309 5.5118 3.10511 5.24686 2.91613C4.98192 2.72715 4.92034 2.35917 5.10932 2.09422L5.4515 1.6145M11.7089 4.21776L12.0511 3.73803C12.24 3.47309 12.1785 3.10511 11.9135 2.91613C11.6486 2.72715 11.587 2.35917 11.776 2.09422L12.1182 1.6145M8.37555 4.21776L8.71773 3.73803C8.90672 3.47309 8.84514 3.10511 8.58019 2.91613C8.31525 2.72715 8.25367 2.35917 8.44265 2.09422L8.78484 1.6145",
    stroke: "#4079FC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreak);
export default __webpack_public_path__ + "static/media/Break.7cc44cc47cb4e2f001b0fcd63e2c7bc6.svg";
export { ForwardRef as ReactComponent };